<div
  class="delete-role-dialog">
  <h2 class="headline">{{'VIRTUAL_POS_PAGE.MODAL_DELETE_GROUP.TITLE' | translate}}</h2>
  <p class="description">{{'VIRTUAL_POS_PAGE.MODAL_DELETE_GROUP.DESCRIPTION' | translate}}</p>
  <h3 class="subtitle">{{'VIRTUAL_POS_PAGE.MODAL_DELETE_GROUP.DESCRIPTION_2' | translate}} {{deleteGroup.length}}</h3>
  <div class="btn-block">
    <button
      (click)="deleteCash()"
      class="btn btn-danger">
      {{'VIRTUAL_POS_PAGE.MODAL_DELETE_GROUP.DELETE' | translate}}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{'VIRTUAL_POS_PAGE.MODAL_DELETE_GROUP.CANCEL' | translate}}
    </button>
  </div>
</div>
